import axios from "axios";
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");

export const get_all_employee_attendance = async () => {
    const response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/get-employee-attendance`)
    return response.data;
}
export const get_single_employee_attendance_log = async (id) => {
    let response = await axios.get(`${baseURL}/api/employee-attendance-activity-log/${id}`);
    return response.data;
  }
  // List of shifts
export const get_all_active_shifts = async () => {
    let response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/select-location-base-shifts`);
    return response.data;
}
// Delete shift
export const delete_employee_attendance = async (id: number) => {
    let response = await axios.delete(`${baseURL}/api/employee-attendance/${id}`);
    return response.data;
}
// Update shift
export const update_employee_attendance = async (id: number, userId, shiftId, dateTime, attendanceId,notes) => {
    let response = await axios.patch(`${baseURL}/api/employee-attendance/${id}`, {
        user_id: userId,
        shift_id: shiftId,
        employee_attendance_notes:notes,
        attendance_type_id: attendanceId,
        attendance_datetime: dateTime
    });
    return response.data;
}
export const get_all_filtered_attendance = async (filterPayload) => {
    const response = await axios.get(baseURL + '/api/get-employee-attendance-by-filter', {
        params: filterPayload
    });
    return response.data;
};
export const add_employee_attendance = async (shiftId, dateTime, attendanceId,employee_attendance_notes) => {
    const response = await axios.post(baseURL + '/api/add-attendance-by-employee', {
      shift_id:shiftId,
      employee_attendance_notes:employee_attendance_notes,
      attendance_type_id: attendanceId,
      attendance_datetime: dateTime
    });
    return response.data;
  };